export default function HeroSection() {
  const scrollToForm = () => {
    const formSection = document.getElementById('contact-form-section');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/f769d25f73ab093865ddcad5bba247c1.jpg)'
        }}
      ></div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-20">
        <div className="inline-block px-5 py-2 bg-teal-500/90 text-white rounded-full text-sm font-bold mb-6 backdrop-blur-sm">
          Fast • Fair • No Obligation
        </div>

        <h1 
          className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight"
          style={{ fontFamily: 'Poppins, sans-serif' }}
        >
          Get Your <strong className="text-teal-400">Cash Offer</strong> Today
        </h1>

        <p className="text-xl md:text-2xl text-white/95 mb-8 max-w-3xl mx-auto leading-relaxed">
          Sell your house fast in El Paso. No repairs, no fees, no hassle. We buy houses in any condition and close on your timeline.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="w-14 h-14 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Close in 7 Days</h3>
            <p className="text-white/80 text-sm">We can close on your timeline, as fast as 7 days or whenever works for you</p>
          </div>

          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="w-14 h-14 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-money-dollar-circle-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">All Cash Offer</h3>
            <p className="text-white/80 text-sm">No financing contingencies. Get a fair, all-cash offer within 24 hours</p>
          </div>

          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="w-14 h-14 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-home-smile-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Any Condition</h3>
            <p className="text-white/80 text-sm">We buy houses as-is. No repairs, no cleaning, no staging required</p>
          </div>
        </div>
      </div>
    </section>
  );
}
